export const cardsData = [
  {
    id: 1,
    title: "Delicias",
    description: "Sabores únicos para compartir",
    images: [
        {
            id: 2,
            src: "https://i.imgur.com/UJY8Px2.png",
            alt: "Delicias - Productos"
          },
      {
        id: 1,
        src: "https://i.imgur.com/bxvw8HF.png",
        alt: "Delicias - Vista principal"
      },
      {
        id: 6,
        src: "https://i.imgur.com/IGXmpY1.png",
        alt: "Delicias - Exterior"
      },
      {
        id: 5,
        src: "https://i.imgur.com/VVOWnzh.png",
        alt: "Delicias - Exterior"
      },
      {
        id: 3,
        src: "https://i.imgur.com/lNSqB4y.png",
        alt: "Delicias - Interior"
      },
      {
        id: 4,
        src: "https://i.imgur.com/2jDbnbS.png",
        alt: "Delicias - Exterior"
      }
    ],
    link: "https://www.instagram.com/humendelicias/"
  },
  {
    id: 2,
    title: "Mini Market",
    description: "Ubicados en el centro neurálgico del Barrio Pujol",
    images: [
      {
        id: 1,
        src: "https://i.imgur.com/wxCBUvA.png",
        alt: "Mini Market - Fachada"
      }
    ],
    link: "https://www.instagram.com/humen.minimarket/"
  }
]; 